(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-toast-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-toast-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-toast-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-toast-js-legacy'.");
    }root['kvision-kvision-toast-js-legacy'] = factory(typeof this['kvision-kvision-toast-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-toast-js-legacy'], kotlin, this['kvision-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var ModuleInitializer = $module$kvision_js_legacy.io.kvision.ModuleInitializer;
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwISE = Kotlin.throwISE;
  var Object_init = Object;
  ToastType.prototype = Object.create(Enum.prototype);
  ToastType.prototype.constructor = ToastType;
  ToastPosition.prototype = Object.create(Enum.prototype);
  ToastPosition.prototype.constructor = ToastPosition;
  function ToastModule() {
    ToastModule_instance = this;
    this.toastr_8be2vx$ = require('toastr');
  }
  ToastModule.prototype.initialize = function () {
    require('toastr/build/toastr.min.css');
  };
  ToastModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'ToastModule', interfaces: [ModuleInitializer]};
  var ToastModule_instance = null;
  function ToastModule_getInstance() {
    if (ToastModule_instance === null) {
      new ToastModule();
    }return ToastModule_instance;
  }
  function ToastType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ToastType_initFields() {
    ToastType_initFields = function () {
    };
    ToastType$INFO_instance = new ToastType('INFO', 0, 'info');
    ToastType$SUCCESS_instance = new ToastType('SUCCESS', 1, 'success');
    ToastType$WARNING_instance = new ToastType('WARNING', 2, 'warning');
    ToastType$ERROR_instance = new ToastType('ERROR', 3, 'error');
  }
  var ToastType$INFO_instance;
  function ToastType$INFO_getInstance() {
    ToastType_initFields();
    return ToastType$INFO_instance;
  }
  var ToastType$SUCCESS_instance;
  function ToastType$SUCCESS_getInstance() {
    ToastType_initFields();
    return ToastType$SUCCESS_instance;
  }
  var ToastType$WARNING_instance;
  function ToastType$WARNING_getInstance() {
    ToastType_initFields();
    return ToastType$WARNING_instance;
  }
  var ToastType$ERROR_instance;
  function ToastType$ERROR_getInstance() {
    ToastType_initFields();
    return ToastType$ERROR_instance;
  }
  ToastType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ToastType', interfaces: [Enum]};
  function ToastType$values() {
    return [ToastType$INFO_getInstance(), ToastType$SUCCESS_getInstance(), ToastType$WARNING_getInstance(), ToastType$ERROR_getInstance()];
  }
  ToastType.values = ToastType$values;
  function ToastType$valueOf(name) {
    switch (name) {
      case 'INFO':
        return ToastType$INFO_getInstance();
      case 'SUCCESS':
        return ToastType$SUCCESS_getInstance();
      case 'WARNING':
        return ToastType$WARNING_getInstance();
      case 'ERROR':
        return ToastType$ERROR_getInstance();
      default:throwISE('No enum constant io.kvision.toast.ToastType.' + name);
    }
  }
  ToastType.valueOf_61zpoe$ = ToastType$valueOf;
  function ToastPosition(name, ordinal, position) {
    Enum.call(this);
    this.position_8be2vx$ = position;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ToastPosition_initFields() {
    ToastPosition_initFields = function () {
    };
    ToastPosition$TOPRIGHT_instance = new ToastPosition('TOPRIGHT', 0, 'toast-top-right');
    ToastPosition$BOTTOMRIGHT_instance = new ToastPosition('BOTTOMRIGHT', 1, 'toast-bottom-right');
    ToastPosition$BOTTOMLEFT_instance = new ToastPosition('BOTTOMLEFT', 2, 'toast-bottom-left');
    ToastPosition$TOPLEFT_instance = new ToastPosition('TOPLEFT', 3, 'toast-top-left');
    ToastPosition$TOPFULLWIDTH_instance = new ToastPosition('TOPFULLWIDTH', 4, 'toast-top-full-width');
    ToastPosition$BOTTOMFULLWIDTH_instance = new ToastPosition('BOTTOMFULLWIDTH', 5, 'toast-bottom-full-width');
    ToastPosition$TOPCENTER_instance = new ToastPosition('TOPCENTER', 6, 'toast-top-center');
    ToastPosition$BOTTOMCENTER_instance = new ToastPosition('BOTTOMCENTER', 7, 'toast-bottom-center');
  }
  var ToastPosition$TOPRIGHT_instance;
  function ToastPosition$TOPRIGHT_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$TOPRIGHT_instance;
  }
  var ToastPosition$BOTTOMRIGHT_instance;
  function ToastPosition$BOTTOMRIGHT_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$BOTTOMRIGHT_instance;
  }
  var ToastPosition$BOTTOMLEFT_instance;
  function ToastPosition$BOTTOMLEFT_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$BOTTOMLEFT_instance;
  }
  var ToastPosition$TOPLEFT_instance;
  function ToastPosition$TOPLEFT_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$TOPLEFT_instance;
  }
  var ToastPosition$TOPFULLWIDTH_instance;
  function ToastPosition$TOPFULLWIDTH_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$TOPFULLWIDTH_instance;
  }
  var ToastPosition$BOTTOMFULLWIDTH_instance;
  function ToastPosition$BOTTOMFULLWIDTH_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$BOTTOMFULLWIDTH_instance;
  }
  var ToastPosition$TOPCENTER_instance;
  function ToastPosition$TOPCENTER_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$TOPCENTER_instance;
  }
  var ToastPosition$BOTTOMCENTER_instance;
  function ToastPosition$BOTTOMCENTER_getInstance() {
    ToastPosition_initFields();
    return ToastPosition$BOTTOMCENTER_instance;
  }
  ToastPosition.$metadata$ = {kind: Kind_CLASS, simpleName: 'ToastPosition', interfaces: [Enum]};
  function ToastPosition$values() {
    return [ToastPosition$TOPRIGHT_getInstance(), ToastPosition$BOTTOMRIGHT_getInstance(), ToastPosition$BOTTOMLEFT_getInstance(), ToastPosition$TOPLEFT_getInstance(), ToastPosition$TOPFULLWIDTH_getInstance(), ToastPosition$BOTTOMFULLWIDTH_getInstance(), ToastPosition$TOPCENTER_getInstance(), ToastPosition$BOTTOMCENTER_getInstance()];
  }
  ToastPosition.values = ToastPosition$values;
  function ToastPosition$valueOf(name) {
    switch (name) {
      case 'TOPRIGHT':
        return ToastPosition$TOPRIGHT_getInstance();
      case 'BOTTOMRIGHT':
        return ToastPosition$BOTTOMRIGHT_getInstance();
      case 'BOTTOMLEFT':
        return ToastPosition$BOTTOMLEFT_getInstance();
      case 'TOPLEFT':
        return ToastPosition$TOPLEFT_getInstance();
      case 'TOPFULLWIDTH':
        return ToastPosition$TOPFULLWIDTH_getInstance();
      case 'BOTTOMFULLWIDTH':
        return ToastPosition$BOTTOMFULLWIDTH_getInstance();
      case 'TOPCENTER':
        return ToastPosition$TOPCENTER_getInstance();
      case 'BOTTOMCENTER':
        return ToastPosition$BOTTOMCENTER_getInstance();
      default:throwISE('No enum constant io.kvision.toast.ToastPosition.' + name);
    }
  }
  ToastPosition.valueOf_61zpoe$ = ToastPosition$valueOf;
  var ToastEasing$SWING_instance;
  var ToastEasing$LINEAR_instance;
  var ToastMethod$FADEIN_instance;
  var ToastMethod$FADEOUT_instance;
  var ToastMethod$SLIDEUP_instance;
  var ToastMethod$SLIDEDOWN_instance;
  var ToastMethod$SHOW_instance;
  var ToastMethod$HIDE_instance;
  function ToastOptions(positionClass, escapeHtml, closeButton, closeHtml, closeDuration, newestOnTop, showEasing, hideEasing, closeEasing, showMethod, hideMethod, closeMethod, preventDuplicates, timeOut, extendedTimeOut, progressBar, rtl, onShown, onHidden, onClick, onCloseClick) {
    if (positionClass === void 0)
      positionClass = null;
    if (escapeHtml === void 0)
      escapeHtml = null;
    if (closeButton === void 0)
      closeButton = null;
    if (closeHtml === void 0)
      closeHtml = null;
    if (closeDuration === void 0)
      closeDuration = null;
    if (newestOnTop === void 0)
      newestOnTop = null;
    if (showEasing === void 0)
      showEasing = null;
    if (hideEasing === void 0)
      hideEasing = null;
    if (closeEasing === void 0)
      closeEasing = null;
    if (showMethod === void 0)
      showMethod = null;
    if (hideMethod === void 0)
      hideMethod = null;
    if (closeMethod === void 0)
      closeMethod = null;
    if (preventDuplicates === void 0)
      preventDuplicates = null;
    if (timeOut === void 0)
      timeOut = null;
    if (extendedTimeOut === void 0)
      extendedTimeOut = null;
    if (progressBar === void 0)
      progressBar = null;
    if (rtl === void 0)
      rtl = null;
    if (onShown === void 0)
      onShown = null;
    if (onHidden === void 0)
      onHidden = null;
    if (onClick === void 0)
      onClick = null;
    if (onCloseClick === void 0)
      onCloseClick = null;
    this.positionClass = positionClass;
    this.escapeHtml = escapeHtml;
    this.closeButton = closeButton;
    this.closeHtml = closeHtml;
    this.closeDuration = closeDuration;
    this.newestOnTop = newestOnTop;
    this.showEasing = showEasing;
    this.hideEasing = hideEasing;
    this.closeEasing = closeEasing;
    this.showMethod = showMethod;
    this.hideMethod = hideMethod;
    this.closeMethod = closeMethod;
    this.preventDuplicates = preventDuplicates;
    this.timeOut = timeOut;
    this.extendedTimeOut = extendedTimeOut;
    this.progressBar = progressBar;
    this.rtl = rtl;
    this.onShown = onShown;
    this.onHidden = onHidden;
    this.onClick = onClick;
    this.onCloseClick = onCloseClick;
  }
  ToastOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'ToastOptions', interfaces: []};
  ToastOptions.prototype.component1 = function () {
    return this.positionClass;
  };
  ToastOptions.prototype.component2 = function () {
    return this.escapeHtml;
  };
  ToastOptions.prototype.component3 = function () {
    return this.closeButton;
  };
  ToastOptions.prototype.component4 = function () {
    return this.closeHtml;
  };
  ToastOptions.prototype.component5 = function () {
    return this.closeDuration;
  };
  ToastOptions.prototype.component6 = function () {
    return this.newestOnTop;
  };
  ToastOptions.prototype.component7 = function () {
    return this.showEasing;
  };
  ToastOptions.prototype.component8 = function () {
    return this.hideEasing;
  };
  ToastOptions.prototype.component9 = function () {
    return this.closeEasing;
  };
  ToastOptions.prototype.component10 = function () {
    return this.showMethod;
  };
  ToastOptions.prototype.component11 = function () {
    return this.hideMethod;
  };
  ToastOptions.prototype.component12 = function () {
    return this.closeMethod;
  };
  ToastOptions.prototype.component13 = function () {
    return this.preventDuplicates;
  };
  ToastOptions.prototype.component14 = function () {
    return this.timeOut;
  };
  ToastOptions.prototype.component15 = function () {
    return this.extendedTimeOut;
  };
  ToastOptions.prototype.component16 = function () {
    return this.progressBar;
  };
  ToastOptions.prototype.component17 = function () {
    return this.rtl;
  };
  ToastOptions.prototype.component18 = function () {
    return this.onShown;
  };
  ToastOptions.prototype.component19 = function () {
    return this.onHidden;
  };
  ToastOptions.prototype.component20 = function () {
    return this.onClick;
  };
  ToastOptions.prototype.component21 = function () {
    return this.onCloseClick;
  };
  ToastOptions.prototype.copy_i5iayh$ = function (positionClass, escapeHtml, closeButton, closeHtml, closeDuration, newestOnTop, showEasing, hideEasing, closeEasing, showMethod, hideMethod, closeMethod, preventDuplicates, timeOut, extendedTimeOut, progressBar, rtl, onShown, onHidden, onClick, onCloseClick) {
    return new ToastOptions(positionClass === void 0 ? this.positionClass : positionClass, escapeHtml === void 0 ? this.escapeHtml : escapeHtml, closeButton === void 0 ? this.closeButton : closeButton, closeHtml === void 0 ? this.closeHtml : closeHtml, closeDuration === void 0 ? this.closeDuration : closeDuration, newestOnTop === void 0 ? this.newestOnTop : newestOnTop, showEasing === void 0 ? this.showEasing : showEasing, hideEasing === void 0 ? this.hideEasing : hideEasing, closeEasing === void 0 ? this.closeEasing : closeEasing, showMethod === void 0 ? this.showMethod : showMethod, hideMethod === void 0 ? this.hideMethod : hideMethod, closeMethod === void 0 ? this.closeMethod : closeMethod, preventDuplicates === void 0 ? this.preventDuplicates : preventDuplicates, timeOut === void 0 ? this.timeOut : timeOut, extendedTimeOut === void 0 ? this.extendedTimeOut : extendedTimeOut, progressBar === void 0 ? this.progressBar : progressBar, rtl === void 0 ? this.rtl : rtl, onShown === void 0 ? this.onShown : onShown, onHidden === void 0 ? this.onHidden : onHidden, onClick === void 0 ? this.onClick : onClick, onCloseClick === void 0 ? this.onCloseClick : onCloseClick);
  };
  ToastOptions.prototype.toString = function () {
    return 'ToastOptions(positionClass=' + Kotlin.toString(this.positionClass) + (', escapeHtml=' + Kotlin.toString(this.escapeHtml)) + (', closeButton=' + Kotlin.toString(this.closeButton)) + (', closeHtml=' + Kotlin.toString(this.closeHtml)) + (', closeDuration=' + Kotlin.toString(this.closeDuration)) + (', newestOnTop=' + Kotlin.toString(this.newestOnTop)) + (', showEasing=' + Kotlin.toString(this.showEasing)) + (', hideEasing=' + Kotlin.toString(this.hideEasing)) + (', closeEasing=' + Kotlin.toString(this.closeEasing)) + (', showMethod=' + Kotlin.toString(this.showMethod)) + (', hideMethod=' + Kotlin.toString(this.hideMethod)) + (', closeMethod=' + Kotlin.toString(this.closeMethod)) + (', preventDuplicates=' + Kotlin.toString(this.preventDuplicates)) + (', timeOut=' + Kotlin.toString(this.timeOut)) + (', extendedTimeOut=' + Kotlin.toString(this.extendedTimeOut)) + (', progressBar=' + Kotlin.toString(this.progressBar)) + (', rtl=' + Kotlin.toString(this.rtl)) + (', onShown=' + Kotlin.toString(this.onShown)) + (', onHidden=' + Kotlin.toString(this.onHidden)) + (', onClick=' + Kotlin.toString(this.onClick)) + (', onCloseClick=' + Kotlin.toString(this.onCloseClick)) + ')';
  };
  ToastOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.positionClass) | 0;
    result = result * 31 + Kotlin.hashCode(this.escapeHtml) | 0;
    result = result * 31 + Kotlin.hashCode(this.closeButton) | 0;
    result = result * 31 + Kotlin.hashCode(this.closeHtml) | 0;
    result = result * 31 + Kotlin.hashCode(this.closeDuration) | 0;
    result = result * 31 + Kotlin.hashCode(this.newestOnTop) | 0;
    result = result * 31 + Kotlin.hashCode(this.showEasing) | 0;
    result = result * 31 + Kotlin.hashCode(this.hideEasing) | 0;
    result = result * 31 + Kotlin.hashCode(this.closeEasing) | 0;
    result = result * 31 + Kotlin.hashCode(this.showMethod) | 0;
    result = result * 31 + Kotlin.hashCode(this.hideMethod) | 0;
    result = result * 31 + Kotlin.hashCode(this.closeMethod) | 0;
    result = result * 31 + Kotlin.hashCode(this.preventDuplicates) | 0;
    result = result * 31 + Kotlin.hashCode(this.timeOut) | 0;
    result = result * 31 + Kotlin.hashCode(this.extendedTimeOut) | 0;
    result = result * 31 + Kotlin.hashCode(this.progressBar) | 0;
    result = result * 31 + Kotlin.hashCode(this.rtl) | 0;
    result = result * 31 + Kotlin.hashCode(this.onShown) | 0;
    result = result * 31 + Kotlin.hashCode(this.onHidden) | 0;
    result = result * 31 + Kotlin.hashCode(this.onClick) | 0;
    result = result * 31 + Kotlin.hashCode(this.onCloseClick) | 0;
    return result;
  };
  ToastOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.positionClass, other.positionClass) && Kotlin.equals(this.escapeHtml, other.escapeHtml) && Kotlin.equals(this.closeButton, other.closeButton) && Kotlin.equals(this.closeHtml, other.closeHtml) && Kotlin.equals(this.closeDuration, other.closeDuration) && Kotlin.equals(this.newestOnTop, other.newestOnTop) && Kotlin.equals(this.showEasing, other.showEasing) && Kotlin.equals(this.hideEasing, other.hideEasing) && Kotlin.equals(this.closeEasing, other.closeEasing) && Kotlin.equals(this.showMethod, other.showMethod) && Kotlin.equals(this.hideMethod, other.hideMethod) && Kotlin.equals(this.closeMethod, other.closeMethod) && Kotlin.equals(this.preventDuplicates, other.preventDuplicates) && Kotlin.equals(this.timeOut, other.timeOut) && Kotlin.equals(this.extendedTimeOut, other.extendedTimeOut) && Kotlin.equals(this.progressBar, other.progressBar) && Kotlin.equals(this.rtl, other.rtl) && Kotlin.equals(this.onShown, other.onShown) && Kotlin.equals(this.onHidden, other.onHidden) && Kotlin.equals(this.onClick, other.onClick) && Kotlin.equals(this.onCloseClick, other.onCloseClick)))));
  };
  function toJs($receiver) {
    var $receiver_0 = new Object_init();
    if ($receiver.positionClass != null)
      $receiver_0.positionClass = $receiver.positionClass.position_8be2vx$;
    if ($receiver.escapeHtml != null)
      $receiver_0.escapeHtml = $receiver.escapeHtml;
    if ($receiver.closeButton != null)
      $receiver_0.closeButton = $receiver.closeButton;
    if ($receiver.closeHtml != null)
      $receiver_0.closeHtml = $receiver.closeHtml;
    if ($receiver.closeDuration != null)
      $receiver_0.closeDuration = $receiver.closeDuration;
    if ($receiver.newestOnTop != null)
      $receiver_0.newestOnTop = $receiver.newestOnTop;
    if ($receiver.showEasing != null)
      $receiver_0.showEasing = $receiver.showEasing.easing_8be2vx$;
    if ($receiver.hideEasing != null)
      $receiver_0.hideEasing = $receiver.hideEasing.easing_8be2vx$;
    if ($receiver.closeEasing != null)
      $receiver_0.closeEasing = $receiver.closeEasing.easing_8be2vx$;
    if ($receiver.showMethod != null)
      $receiver_0.showMethod = $receiver.showMethod.method_8be2vx$;
    if ($receiver.hideMethod != null)
      $receiver_0.hideMethod = $receiver.hideMethod.method_8be2vx$;
    if ($receiver.closeMethod != null)
      $receiver_0.closeMethod = $receiver.closeMethod.method_8be2vx$;
    if ($receiver.preventDuplicates != null)
      $receiver_0.preventDuplicates = $receiver.preventDuplicates;
    if ($receiver.timeOut != null)
      $receiver_0.timeOut = $receiver.timeOut;
    if ($receiver.extendedTimeOut != null)
      $receiver_0.extendedTimeOut = $receiver.extendedTimeOut;
    if ($receiver.progressBar != null)
      $receiver_0.progressBar = $receiver.progressBar;
    if ($receiver.rtl != null)
      $receiver_0.rtl = $receiver.rtl;
    if ($receiver.onShown != null)
      $receiver_0.onShown = $receiver.onShown;
    if ($receiver.onHidden != null)
      $receiver_0.onHidden = $receiver.onHidden;
    if ($receiver.onClick != null)
      $receiver_0.onclick = $receiver.onClick;
    if ($receiver.onCloseClick != null)
      $receiver_0.onCloseClick = $receiver.onCloseClick;
    return $receiver_0;
  }
  function Toast() {
    Toast_instance = this;
    ToastModule_getInstance().initialize();
  }
  Toast.prototype.success_8mmk05$ = function (message, title, options) {
    if (title === void 0)
      title = null;
    if (options === void 0)
      options = null;
    this.show_0(ToastType$SUCCESS_getInstance(), message, title, options);
  };
  Toast.prototype.info_8mmk05$ = function (message, title, options) {
    if (title === void 0)
      title = null;
    if (options === void 0)
      options = null;
    this.show_0(ToastType$INFO_getInstance(), message, title, options);
  };
  Toast.prototype.warning_8mmk05$ = function (message, title, options) {
    if (title === void 0)
      title = null;
    if (options === void 0)
      options = null;
    this.show_0(ToastType$WARNING_getInstance(), message, title, options);
  };
  Toast.prototype.error_8mmk05$ = function (message, title, options) {
    if (title === void 0)
      title = null;
    if (options === void 0)
      options = null;
    this.show_0(ToastType$ERROR_getInstance(), message, title, options);
  };
  Toast.prototype.show_0 = function (type, message, title, options) {
    if (title === void 0)
      title = null;
    if (options === void 0)
      options = null;
    if (options != null) {
      ToastModule_getInstance().toastr_8be2vx$[type.type_8be2vx$](message, title, toJs(options));
    } else {
      ToastModule_getInstance().toastr_8be2vx$[type.type_8be2vx$](message, title);
    }
  };
  Toast.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Toast', interfaces: []};
  var Toast_instance = null;
  function Toast_getInstance() {
    if (Toast_instance === null) {
      new Toast();
    }return Toast_instance;
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'ToastModule', {get: ToastModule_getInstance});
  Object.defineProperty(ToastType, 'INFO', {get: ToastType$INFO_getInstance});
  Object.defineProperty(ToastType, 'SUCCESS', {get: ToastType$SUCCESS_getInstance});
  Object.defineProperty(ToastType, 'WARNING', {get: ToastType$WARNING_getInstance});
  Object.defineProperty(ToastType, 'ERROR', {get: ToastType$ERROR_getInstance});
  var package$toast = package$kvision.toast || (package$kvision.toast = {});
  package$toast.ToastType = ToastType;
  Object.defineProperty(ToastPosition, 'TOPRIGHT', {get: ToastPosition$TOPRIGHT_getInstance});
  Object.defineProperty(ToastPosition, 'BOTTOMRIGHT', {get: ToastPosition$BOTTOMRIGHT_getInstance});
  Object.defineProperty(ToastPosition, 'BOTTOMLEFT', {get: ToastPosition$BOTTOMLEFT_getInstance});
  Object.defineProperty(ToastPosition, 'TOPLEFT', {get: ToastPosition$TOPLEFT_getInstance});
  Object.defineProperty(ToastPosition, 'TOPFULLWIDTH', {get: ToastPosition$TOPFULLWIDTH_getInstance});
  Object.defineProperty(ToastPosition, 'BOTTOMFULLWIDTH', {get: ToastPosition$BOTTOMFULLWIDTH_getInstance});
  Object.defineProperty(ToastPosition, 'TOPCENTER', {get: ToastPosition$TOPCENTER_getInstance});
  Object.defineProperty(ToastPosition, 'BOTTOMCENTER', {get: ToastPosition$BOTTOMCENTER_getInstance});
  package$toast.ToastPosition = ToastPosition;
  package$toast.ToastOptions = ToastOptions;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  package$toast.toJs_ki7fv$ = toJs;
  Object.defineProperty(package$toast, 'Toast', {get: Toast_getInstance});
  return _;
}));

//# sourceMappingURL=kvision-kvision-toast-js-legacy.js.map
